import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "@/utils/cn";
const badgeVariants = cva("inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-(--ring) focus-visible:ring-(--ring)/50 focus-visible:ring-[3px] aria-invalid:ring-(--destructive)/20 dark:aria-invalid:ring-(--destructive)/40 aria-invalid:border-(--destructive) transition-[color,box-shadow] overflow-hidden", {
    variants: {
        variant: {
            default: "border-transparent bg-(--primary) text-(--primary-foreground) [a&]:hover:bg-(--primary)/90",
            secondary: "border-transparent bg-(--secondary) text-(--secondary-foreground) [a&]:hover:bg-(--secondary)/90",
            destructive: "border-transparent bg-(--destructive) text-white [a&]:hover:bg-(--destructive)/90 focus-visible:ring-(--destructive)/20 dark:focus-visible:ring-(--destructive)/40 dark:bg-(--destructive)/60",
            success: "border-transparent bg-(--success) text-(--success-foreground) [a&]:hover:bg-(--success)/90 focus-visible:ring-(--success)/20 dark:focus-visible:ring-(--success)/40 dark:bg-(--success)/60",
            fail: "border-transparent bg-red-50 text-red-700 [a&]:hover:bg-red-50/90 focus-visible:ring-red-50/20 dark:focus-visible:ring-red-50/40 dark:bg-red-50/60",
            outline: "text-(--foreground) [a&]:hover:bg-(--accent) [a&]:hover:text-(--accent-foreground)"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
function Badge({ className, variant, ...props }) {
    return React.createElement("span", { className: cn(badgeVariants({ variant }), className), ...props });
}
export { Badge, badgeVariants };
